import { PHOTO_CONTAINER } from "../constants"

class ContainerElement {
  constructor(element) {
    this.element = element
    this._onClickCallbackList = []

    this.element.addEventListener("click", (event) => {
      // Only handle clicks on the container itself, not child elements
      if (event.target === this.element) {
        this._onClickCallbackList.forEach((callback) => callback(event))
      }
    })
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_CONTAINER)
    return element ? new ContainerElement(element) : null
  }

  onClick(callback) {
    this._onClickCallbackList.push(callback)
  }
}

export default ContainerElement
